import React from 'react';
import { Prompt, Redirect } from 'react-router-dom';
import BackButton from '../shared/BackButton';
import DetailsBar from '../shared/DetailsBar';
import TextAreaModal from '../shared/TextAreaModal';
import TextAreaView from '../shared/TextAreaView';
import HeadingPlaceholder from '../shared/HeadingPlaceholder';
import ModalEnabledComponent from '../extend/ModalEnabled';
import ProductEditDetailsModal from '../product/ProductEditDetailsModal';
import ProductPricingModal from '../product/ProductPricingModal';
import ProductPricingView from '../product/ProductPricingView';
import ProductDeleteModal from '../product/ProductDeleteModal';
import SVGTrash from '../../svg/Trash';
import { menuAPI } from '../../InterfaceAPI/menuAPI';
import { isEmpty, stringfyServerErrors } from '../../helpers/util';
import withSplashMessage from '../splashMessage/withSplashMessage';
import withTracker from '../withTracker';

class AdminProduct extends ModalEnabledComponent {
  state = {
    product: {
      name: '',
      product_category: {},
      product_format: {},
      product_vendor: {},
      allergen_tags: [],
      notes: '',
      paid_price_cents: 0,
      unit_price_cents: 0,
      yield_grams: 0,
      product_unit: {}
    },
    openModal: '',
    unsaved: false,
    redirect_to: false
  };

  detailsBarProperties = [
    { label: 'Category', key: 'product_category', dive: 'name' },
    { label: 'Purchase Unit', key: 'product_format', dive: 'name' },
    { label: 'Vendor', key: 'product_vendor', dive: 'name' },
    { label: 'Allergens', key: 'allergen_tags', dive: 'tag' }
  ];

  render() {
    const { product, redirect_to, unsaved } = this.state;
    const {
      detailsBarProperties,
      isOpen,
      openModal,
      closeModal,
      updateProduct,
      deleteProduct
    } = this;
    // const name = product.name || 'Product Name';

    if (redirect_to) return <Redirect to={redirect_to} />;

    return (
      <div className="products cms">
        <div className="cms__head cms__head--padding">
          <div className="cms__content">
            <BackButton defaultUrl="/admin/products" />
            <div className="cms__bar">
              <div className="cms__bar-left">
                <HeadingPlaceholder
                  value={product.name}
                  placeholder="Product Name"
                  label="Product Name"
                />
              </div>
              <div className="cms__bar-item cms__bar-right">
                {this.renderDeleteButton(product)}
                <div
                  className="btn btn--hollow-blue"
                  onClick={() => openModal('edit-details')}
                >
                  Edit Details
                </div>
                {this.renderSaveButton(product)}
              </div>
            </div>
            <DetailsBar data={product} columns={detailsBarProperties} />
          </div>
        </div>

        <div className="cms__body">
          <div className="cms__content">
            <div className="row">
              <div className="row__item row__item--half row__item--pad-right">
                <ProductPricingView
                  product={product}
                  openEdit={() => openModal('pricing')}
                />
              </div>
              <div className="row__item row__item--half row__item--pad-left">
                <TextAreaView
                  value={product.notes}
                  openEdit={() => openModal('notes')}
                />
              </div>
            </div>
          </div>
        </div>

        <ProductEditDetailsModal
          isOpen={isOpen('edit-details')}
          closeModal={closeModal}
          product={product}
          updateProduct={updateProduct}
        />

        <ProductPricingModal
          isOpen={isOpen('pricing')}
          closeModal={closeModal}
          product={product}
          updateProduct={updateProduct}
        />

        <TextAreaModal
          isOpen={isOpen('notes')}
          closeModal={closeModal}
          title="Private Notes"
          value={product.notes}
          onSubmit={notes => updateProduct({ notes })}
        />

        <ProductDeleteModal
          isOpen={isOpen('delete')}
          closeModal={closeModal}
          product={product}
          deleteProduct={deleteProduct}
        />

        <Prompt when={unsaved} message="You have unsaved data, are you sure?" />
      </div>
    );
  }

  renderSaveButton = product => {
    const cta = 'id' in product ? 'Update' : 'Add';
    return (
      <div className="btn btn--solid-blue" onClick={this.submit}>
        {cta}
      </div>
    );
  };

  renderDeleteButton = product => {
    const { openModal } = this;
    if ('id' in product && product.id > 0)
      return (
        <div
          className="btn-icon btn-icon--trash"
          onClick={() => openModal('delete')}
        >
          <SVGTrash />
        </div>
      );
  };

  // also closes any open modals
  updateProduct = updatedProduct => {
    const product = {
      ...this.state.product,
      ...updatedProduct
    };

    this.setState({ product, openModal: '', unsaved: true });
  };

  deleteProduct = () => {
    const { product } = this.state;
    menuAPI
      .deleteProduct(product.id)
      .then(result => {
        this.props.addMessage({
          className: 'success',
          message: `"${product.name}" product has been deleted.`
        });
        this.setState({ redirect: true });
      })
      .catch(result => {
        this.props.addMessage({
          className: 'error',
          message: `There was an error attempting to delete.`
        });
        this.closeModal();
      });
  };

  submit = () => {
    const product = { ...this.state.product };
    if (!this.validateProduct(product)) {
      this.props.addMessage({
        className: 'error',
        message: 'Product cannot be saved due to missing information'
      });
      return;
    }

    if ('id' in product)
      menuAPI
        .updateProduct(product)
        .then(product => {
          this.props.addMessage({
            className: 'success',
            message: `"${product.name}" product has been updated.`
          });
          this.setState({ product, redirect: true, unsaved: false });
        })
        .catch(error => {
          console.log(error);
          this.props.addMessage({
            className: 'error',
            message: stringfyServerErrors(error)
          });
        });
    else
      menuAPI
        .createProduct(product)
        .then(product => {
          this.props.addMessage({
            className: 'success',
            message: `"${product.name}" product has been added.`
          });
          this.setState({ product, redirect: true, unsaved: false });
        })
        .catch(error => {
          console.log(error);
          this.props.addMessage({
            className: 'error',
            message: stringfyServerErrors(error)
          });
        });
  };

  validateProduct(product) {
    return (
      'name' in product &&
      !isEmpty(product.name) &&
      // 'paid_price_cents' in product && product.paid_price_cents > 0 &&
      // 'unit_price_cents' in product && product.unit_price_cents > 0 &&
      // 'yield_grams' in product && product.yield_grams > 0 &&
      'product_category' in product &&
      !isEmpty(product.product_category) &&
      'product_format' in product &&
      !isEmpty(product.product_format) &&
      'product_unit' in product &&
      !isEmpty(product.product_unit) &&
      'product_vendor' in product &&
      !isEmpty(product.product_vendor)
    );
  }

  handleErrorLoading = error => {
    const pathname = '/admin/products';
    const redirect_to = { pathname };

    const { state } = this.props.location;
    if (state) {
      const { redirect_url, redirect_payload } = state;
      if (redirect_url) {
        redirect_to.pathname = redirect_url;
      }

      if (redirect_payload) redirect_to.state = { ...redirect_payload };
    }
    this.props.addMessage({
      className: 'error',
      message: stringfyServerErrors(error)
    });
    this.setState({ redirect_to, isLoading: false });
  };

  componentDidMount() {
    const { id } = this.props.match.params;
    if (id > 0)
      menuAPI
        .getProduct(id)
        .then(product => this.setState({ product }))
        .catch(this.handleErrorLoading);
  }
}

export default withSplashMessage(withTracker(AdminProduct));



// WEBPACK FOOTER //
// ./src/components/admin/AdminProduct.js